import { Except } from '@common/types/common.type';
import { StoreConfig } from '@input-web/configs/store/store.config';
import { getStoreBaseActions } from '@input-web/utils/store.util';
import { DialogProps } from '@ui/components/molecules/dialog/dialog.molecule';
import { proxy, useSnapshot } from 'valtio';

// #region Types
export type StandardConfirmationDialogProps = Except<DialogProps, 'onClose' | 'actions'> & {
  onConfirm?: VoidFunction;
  onDecline?: VoidFunction;
};

type StandardState = {
  confirmationDialogProps?: StandardConfirmationDialogProps;
  shouldConfirmLeavingForm: boolean;
};
// #endregion

// #region State
const initial = {
  confirmationDialogProps: undefined,
  shouldConfirmLeavingForm: false,
} satisfies StandardState;
const state = proxy<StandardState>({ ...initial });
// #endregion

// #region Snapshot
export function useStandardStore() {
  return useSnapshot(state);
}
// #endregion

// #region Actions
const actions = {
  ...getStoreBaseActions(state, initial),
  openConfirmationDialog: (confirmationDialogProps: StandardConfirmationDialogProps) => {
    state.confirmationDialogProps = { ...confirmationDialogProps, open: true };
  },
  replaceConfirmationDialogProps: (confirmationDialogProps: StandardConfirmationDialogProps) => {
    state.confirmationDialogProps = confirmationDialogProps;
  },
  setConfirmationDialogProps: (confirmationDialogProps: StandardConfirmationDialogProps) => {
    state.confirmationDialogProps = confirmationDialogProps;
  },
  setShouldConfirmLeavingForm: (shouldConfirmLeavingForm: boolean) => {
    state.shouldConfirmLeavingForm = shouldConfirmLeavingForm;
  },
};
// #endregion

// #region Store
type StandardStore = StoreConfig<StandardState, typeof actions>;
const standardStore: StandardStore = { actions, initial, state };
// #endregion

export default standardStore;
